import { TITLE_MAX_LENGTH } from "@shared/validation";

// Shared by the create form and the per-locale wording form, so the one rule
// an author has to internalise — a title is a label, not the task — is not
// worded two different ways depending on which page they landed on.
export const TITLE_HINT = `The activity plus its one distinguishing word. Up to ${TITLE_MAX_LENGTH} characters, no placeholders: it is never formatted, and it is what lists, history and notifications show. Ten presentation quests must not read alike here.`;
